export enum QuickFilterId {
  All = 'All',
  Active = 'Active',
  Deleted = 'Deleted',
}
